import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import useStyles from './styles';
import IHeroBanner from './types';

function HeroBanner({
  className,
  footer,
  logo,
  headerComponent,
  heading,
  content,
  imgSrc,
  imgAlt,
  imgWidth,
  imgHeight,
  partialBg,
  imgContainerClassName,
  bannerContentClassName,
  alert,
  rating,
  noBoxShadow,
}: IHeroBanner) {
  const classes = useStyles({ noBoxShadow });

  return (
    <section className={classNames(classes.root, className, { partialBg })}>
      {headerComponent && <div className={classes.headerComponent}>{headerComponent}</div>}

      {logo && <header className={classes.header}>{logo}</header>}

      <article className={classes.banner}>
        {alert && (
          <div className={classes.alert}>
            <div className={classes.alertContainer}>{alert}</div>
          </div>
        )}

        <div className={classNames(classes.bannerContent, bannerContentClassName)}>
          {imgSrc && (
            <div className={classNames(classes.imgContainer, imgContainerClassName)}>
              <LazyLoadImage
                src={imgSrc}
                alt={imgAlt}
                width={imgWidth || null}
                height={imgHeight || null}
              />
            </div>
          )}

          <h1 className={classes.heading}>{heading}</h1>

          {content && <p className={classes.content}>{content}</p>}
        </div>
        {footer}
        {rating}
      </article>
    </section>
  );
}

export default HeroBanner;
